import initialState from './initialState';
import {
  AMEX_DISPUTE_STAGES,
  CASE_DATA,
  CASE_DATA_FAILURE,
  CASE_REVISIT,
  RESET_CASE_REVISIT,
  RESET_CASE_UPDATE,
  UNLOAD_CASE_INFO,
} from '../actions/actionTypes';

export default function caseDataReducer(state = initialState.caseInfo, action) {
  switch (action.type) {
    case CASE_DATA: {
      const newCaseNumber = action.caseInfo.caseDetail.caseNumber;
      const currentOpenCases = state.openCases.some((openCase) => openCase.caseDetail.caseNumber === newCaseNumber)
        ? [...state.openCases.filter((openCase) => openCase.caseDetail.caseNumber !== newCaseNumber)]
        : [...state.openCases];
      return {
        ...state,
        openCases: [...currentOpenCases, action.caseInfo],
      };
    }
    case AMEX_DISPUTE_STAGES:
      return {
        ...state,
        disputeStages: {
          ...state.disputeStages,
          amexDisputeStages: action.disputeStages,
        },
      };
    case UNLOAD_CASE_INFO:
      return {
        ...state,
        openCases: [...state.openCases.filter((openCase) => openCase.caseDetail.caseNumber !== action.caseNumber)],
      };
    case RESET_CASE_UPDATE: {
      let caseToReset = state.openCases.filter((openCase) => openCase.caseDetail.caseNumber === action.caseNumber)[0];
      const updatedCase = { ...caseToReset, caseUpdated: false };
      return {
        ...state,
        openCases: [
          ...state.openCases.filter((openCase) => openCase.caseDetail.caseNumber !== action.caseNumber),
          updatedCase,
        ],
      };
    }
    case CASE_DATA_FAILURE: {
      const newCaseNumber = Number(action.caseNumber);
      const currentOpenCases = state.openCases.some((openCase) => openCase.caseDetail.caseNumber === newCaseNumber)
        ? [...state.openCases.filter((openCase) => openCase.caseDetail.caseNumber !== newCaseNumber)]
        : [...state.openCases];
      let failedCase = {
        caseDetail: {
          caseNumber: newCaseNumber,
        },
        failedToLoad: true,
        caseUpdated: true,
      };
      return {
        ...state,
        openCases: [...currentOpenCases, failedCase],
      };
    }
    case CASE_REVISIT: {
      const updatedCases = state.openCases.map((openCase) => {
        return {
          ...openCase,
          isCaseRevisited: true,
        };
      });
      return {
        ...state,
        openCases: [...updatedCases],
      };
    }
    case RESET_CASE_REVISIT: {
      const updatedCases = state.openCases.map((openCase) => {
        return {
          ...openCase,
          isCaseRevisited: false,
        };
      });
      return {
        ...state,
        openCases: [...updatedCases],
      };
    }
    default:
      return state;
  }
}
